import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function PageCanonical() {
    const { pathname } = useLocation();
    useEffect(() => {
        const path = pathname.replace(/\/+$/, '') || '/discover';
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) canonical.href = `https://growdaily.fun${path}`;
        document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(link => link.remove());
        if (/^\/(?:[a-z]{2}\/)?discover$/.test(path)) {
            for (const lang of ['x-default', 'en', 'da', 'de', 'es', 'fr', 'it', 'pt', 'nl', 'pl', 'sv', 'no']) {
                const link = document.createElement('link');
                link.rel = 'alternate';
                link.hreflang = lang;
                link.href = `https://growdaily.fun/${lang === 'x-default' ? 'en' : lang}/discover`;
                document.head.appendChild(link);
            }
        }
    }, [pathname]);
    return null;
}
